<template>
  <path d="M9 16.216q2.954 0 5.085-2.131t2.131-5.085-2.131-5.085-5.085-2.131-5.085 2.131-2.131 5.085 2.131 5.085 5.085 2.131zM9 0.012q3.713 0 6.351 2.637t2.637 6.351-2.637 6.351-6.351 2.637-6.351-2.637-2.637-6.351 2.637-6.351 6.351-2.637zM8.114 4.485h1.772v5.401h-1.772v-5.401zM8.114 11.701h1.772v1.815h-1.772v-1.815z"></path>
</template>
